import { render, staticRenderFns } from "./tab-7-record-excellence.vue?vue&type=template&id=3891f82d&scoped=true&lang=pug&"
import script from "./tab-7-record-excellence.vue?vue&type=script&lang=js&"
export * from "./tab-7-record-excellence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3891f82d",
  null
  
)

export default component.exports